import { render } from "./withdraw.vue?vue&type=template&id=acf1c84e&scoped=true"
import script from "./withdraw.vue?vue&type=script&lang=js"
export * from "./withdraw.vue?vue&type=script&lang=js"

import "./withdraw.vue?vue&type=style&index=0&id=acf1c84e&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\project\\forex\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acf1c84e"]])

export default __exports__